import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import React from 'react';
import { toastr } from 'react-redux-toastr';
import DiscountAccordion from './DiscountAccordion';
import { ReactComponent as AddNewField } from 'assets/icons/Group 239993.svg';

const PriceDiscount = ({ formik, expandedIndex, setExpandedIndex }) => {

  return (
    <div>
      <div className="class_discount_content">
        {formik.values?.discount?.map((_, index) => {
          const isExpanded = index === expandedIndex;

          return (
            <DiscountAccordion
              key={index}
              summary={
                <div className={isExpanded ? 'text-primary' : ''} style={{ display: 'flex', alignItems: 'center' }}>
                  Discount {index + 1 < 10 ? `0${index + 1}` : index + 1}
                  {(() => {
                    const e = formik.errors?.discount?.[index];
                    const hasErr = !!(e && Object.keys(e).length > 0);
                    return hasErr ? <ErrorOutlineIcon style={{ color: '#dc3545', fontSize: 18, marginLeft: 4 }} /> : null;
                  })()}
                </div>
              }
              formik={formik}
              index={index}
              handleDeleteClick={() => {
                const discount = formik.values?.discount;
                discount.splice(index, 1);
                formik.setFieldValue('discount', discount);

                // If the deleted item was the currently expanded one,
                // reset the expanded index to -1
                if (index === expandedIndex) {
                  setExpandedIndex(-1);
                }
              }}
              isExpanded={isExpanded}
              handleExpand={() => {
                setExpandedIndex(isExpanded ? -1 : index);
              }}
            />
          );
        })}
      </div>
      <div
        className="add_new_discount d-flex align-items-center justify-content-center w-100"
        style={{
          height: '40px',
          color: '#002E5C',
          cursor: 'pointer',
          fontSize: '14px',
          marginTop: '24px',
          border: '1px dashed rgba(0, 46, 92, 0.2)',
          borderRadius: '4px',
        }}
        onClick={() => {
          const discounts = formik.values?.discount || [];
          let hasIncomplete = false;
          discounts.forEach((d, i) => {
            if (!d?.discount_name) {
              formik.setFieldError(`discount[${i}].discount_name`, 'Required');
              formik.setFieldTouched(`discount[${i}].discount_name`, true);
              hasIncomplete = true;
            }
            if (!d?.value) {
              formik.setFieldError(`discount[${i}].value`, 'Required');
              formik.setFieldTouched(`discount[${i}].value`, true);
              hasIncomplete = true;
            }
            const type = d?.discount_type?.toLowerCase();
            if (type === 'date') {
              if (!d?.start_date) {
                formik.setFieldError(`discount[${i}].start_date`, 'Required');
                formik.setFieldTouched(`discount[${i}].start_date`, true);
                hasIncomplete = true;
              }
              if (!d?.end_date) {
                formik.setFieldError(`discount[${i}].end_date`, 'Required');
                formik.setFieldTouched(`discount[${i}].end_date`, true);
                hasIncomplete = true;
              }
            }
            if (type === 'quantity' && !d?.quantity) {
              formik.setFieldError(`discount[${i}].quantity`, 'Required');
              formik.setFieldTouched(`discount[${i}].quantity`, true);
              hasIncomplete = true;
            }
            if (type === 'amount' && !d?.amount) {
              formik.setFieldError(`discount[${i}].amount`, 'Required');
              formik.setFieldTouched(`discount[${i}].amount`, true);
              hasIncomplete = true;
            }
          });
          if (hasIncomplete) {
            toastr.info('Incomplete Discounts', 'Please fill in all required fields in existing discounts before adding a new one.');
            return;
          }
          formik.setFieldValue('discount', [
            ...formik.values?.discount,
            {
              discount_name: '',
              price_type: 'fixed',
              value: '',
              discount_type: 'Date',
              start_date: '',
              end_date: '',
            },
          ]);
        }}
      >
        <AddNewField className="mr-2" /> Add discount{' '}
        {formik.values?.discount?.length + 1 < 10
          ? `0${formik.values?.discount?.length + 1}`
          : formik.values?.discount?.length + 1}
      </div>
    </div>
  );
};

export default PriceDiscount;
